import { c as _c } from "react/compiler-runtime";
import { RichText } from 'components/form/RichText';
import { match } from 'ts-pattern';
import { ForecastFetched, UseForecastGroupApp } from './useForecasts';
import { StyleProps } from 'components';
import { isNullOrEmpty } from 'shared/collection';
import { notNull } from 'shared/type';
import { ResolutionForecasts, QuestionCfg, zResolutionValue } from 'shared/forecast';
import { Resolution as R } from 'shared/forecast/resolution';
import { pick, unique } from 'remeda';
import { ResolutionValueEdit } from './Resolution';
import { ResolutionValueIcon } from 'shared/forecast/results/QuestionResults';
import { CardCollapsable } from 'components/Card';
import { SubqDisplayMode, zQuestionQuery } from './questionComponentTypes';
import { useQueryString, useQueryStringValues } from 'utils/useQueryString';
import { ComparisonQForm } from './Comparison';
import { compactString } from 'shared/text';
import { Forecast, type ForecastCommonProps } from './Forecast';
import { useQuestionForm } from './useQuestions';
export const SubqForecasts = t0 => {
  const $ = _c(6);
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      className,
      ...props
    } = t0;
    const {
      resolutionForecasts,
      editing
    } = props;
    t1 = `flex w-full flex-col gap-1 ${className ?? ""}`;
    t2 = resolutionForecasts.map((f, i) => (f.resolution.enableForecasts || editing) && <SubqForecastResolution key={f.code ?? "_"} {...props} resolution={f} />);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
type SubqForecastResolutionProps = {
  question_id: string;
  subquestion_id: string;
  resolution: ResolutionForecasts<ForecastFetched, UseForecastGroupApp>;
  displayMode: SubqDisplayMode;
  subQForm: ComparisonQForm;
  showForecasts?: boolean;
  editing?: boolean;
} & ForecastCommonProps;
const zSubqForecastResolutionQuery = zQuestionQuery.pick({
  subq_resolution_open: true,
  subq_resolution_closed: true
});
const SubqForecastResolution = t0 => {
  const $ = _c(40);
  const {
    showForecasts,
    question_id,
    subquestion_id,
    displayMode,
    subQForm,
    editing,
    resolution,
    color,
    onChange
  } = t0;
  const {
    code,
    resolution: t1,
    group,
    resolutionValue,
    fmt,
    cfg
  } = resolution;
  const {
    label,
    description
  } = t1;
  let t2;
  if ($[0] !== code || $[1] !== subquestion_id) {
    t2 = [subquestion_id, code].filter(notNull);
    $[0] = code;
    $[1] = subquestion_id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const openedKey = t2.join("-");
  let t3;
  if ($[3] !== openedKey) {
    t3 = {
      pick: r => ({
        open: r.subq_resolution_open?.includes(openedKey),
        closed: r.subq_resolution_closed?.includes(openedKey)
      })
    };
    $[3] = openedKey;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const qs = useQueryString(zSubqForecastResolutionQuery, t3);
  const showForecast = (qs.query.open ? true : undefined) ?? (qs.query.closed ? false : undefined) ?? (displayMode != "forecast" || showForecasts);
  let t4;
  if ($[5] !== question_id) {
    t4 = {
      question_id,
      pick: _temp
    };
    $[5] = question_id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const rootQForm = useQuestionForm(t4).form;
  let t5;
  if ($[7] !== openedKey || $[8] !== qs || $[9] !== showForecast) {
    t5 = v => {
      if (showForecast) {
        qs.setQuery(r_1 => ({
          subq_resolution_closed: unique([...(r_1.subq_resolution_closed ?? []), openedKey]),
          subq_resolution_open: r_1.subq_resolution_open?.filter(k => k != openedKey)
        }));
      } else {
        qs.setQuery(r_2 => ({
          subq_resolution_open: unique([...(r_2.subq_resolution_open ?? []), openedKey]),
          subq_resolution_closed: r_2.subq_resolution_closed?.filter(k_0 => k_0 != openedKey)
        }));
      }
    };
    $[7] = openedKey;
    $[8] = qs;
    $[9] = showForecast;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      title: "bg-transparent",
      container: "mb-6"
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== label) {
    t7 = compactString(label) ?? "Forecast";
    $[12] = label;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="grow ">{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== fmt || $[17] !== resolutionValue) {
    t9 = resolutionValue && resolutionValue.status != "pending" && <ResolutionValueIcon {...resolutionValue} fmt={fmt} />;
    $[16] = fmt;
    $[17] = resolutionValue;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex items-center gap-2">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== cfg || $[23] !== color || $[24] !== description || $[25] !== displayMode || $[26] !== editing || $[27] !== group || $[28] !== onChange || $[29] !== resolution || $[30] !== rootQForm || $[31] !== showForecast || $[32] !== subQForm) {
    t11 = showForecast ? <>{!isNullOrEmpty(description) && <RichText className="mb-4" value={description} readonly={true} />}{match(displayMode).with("forecast", () => <Forecast color={color} resolution={resolution} question={cfg} onChange={onChange} qForm={subQForm} showComparison={editing} />).with("resolution", () => {
        const key = R.resolutionKeyString(group.group);
        const resValue = rootQForm.values?.resolutionValues[key] ?? zResolutionValue.parse({});
        return <ResolutionValueEdit className="pt-2" type={cfg.forecastType} {...resValue} unitLabel={cfg.forecastType == "amount" ? cfg.unitLabel : undefined} onChange={v_0 => rootQForm.setFieldValueDynamic(["resolutionValues", key], v_0)} />;
      }).with("order", _temp2).exhaustive()}</> : <></>;
    $[22] = cfg;
    $[23] = color;
    $[24] = description;
    $[25] = displayMode;
    $[26] = editing;
    $[27] = group;
    $[28] = onChange;
    $[29] = resolution;
    $[30] = rootQForm;
    $[31] = showForecast;
    $[32] = subQForm;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== code || $[35] !== showForecast || $[36] !== t10 || $[37] !== t11 || $[38] !== t5) {
    t12 = <CardCollapsable opened={showForecast} onChange={t5} key={code} classNames={t6} title={t10}>{t11}</CardCollapsable>;
    $[34] = code;
    $[35] = showForecast;
    $[36] = t10;
    $[37] = t11;
    $[38] = t5;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
};
function _temp(r_0) {
  return pick(r_0, ["resolutionValues"]);
}
function _temp2() {
  return <></>;
}